<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles orderIssue">
            <van-nav-bar
                title="订单下发"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <van-icon
                    class="iconfont iconshaixuan"
                    slot="right"
                    @click="showPopup('screen')"
                ></van-icon>
            </van-nav-bar>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="isUpLoading"
                    :finished="finished"
                    finished-text="没有更多了!"
                    @load="onLoad"
                >
                    <ul class="list" v-if="orderData.length > 0">
                        <template v-for="(item, index) in orderData">
                            <li :key="index">
                                <div class="engineeringInfo" @click="openOrderDetails(item)">
                                    <h4 class="engineeringInfo_header">
                                        <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                        <span class="headerName">{{ item.customer_name }}</span>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            <span>订单编号：{{ item.order_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2.png" alt="">
                                            <span>工程名称：{{ item.project_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                            <span>供应场站：{{ item.station_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3.png" alt="">
                                            <span>客户名称：{{ item.customer_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>要求到货时间：{{ item.arrival_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>预计完成时间：{{ item.start_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_40.png" alt="">
                                            <span>强度等级：{{ item.strength_grade_name }}{{ ' ' + item.special_require_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>浇筑方式：{{ item.pouring_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>计划方量：{{ item.plan_quantity }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>任务方量：{{ item.quantity }}</span>
                                        </p>
                                    </div>
                                    <span class="state" v-if="item.distributed_status == 0" style="color:#FF6600">未下发</span>
                                    <span class="state" v-if="item.distributed_status == 1" style="color:#00A84B">已下发</span>
                                </div>
                                <div class="form" v-if="item.distributed_status == 0">
                                    <button @click="openOrderDetails(item)">
                                        <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                        下发
                                    </button>
                                </div>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </van-pull-refresh>
            <van-popup
                class="sideslip"
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
            >
                <div class="screen">
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="onClickRight"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>场站</dt>
                            <dd>
                                <van-dropdown-menu>
                                    <van-dropdown-item
                                        style="right:0"
                                        v-model="requestData.station_id"
                                        :options="stationList"
                                    ></van-dropdown-item>
                                </van-dropdown-menu>
                            </dd>
                        </dl>
                        <dl>
                            <dt>单位</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.customer_name"
                                    placeholder="单位"
                                >
                            </dd>
                        </dl>
                        <dl>
                            <dt>工程名称</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.project_name"
                                    placeholder="工程名称"
                                >
                            </dd>
                        </dl>
                        <dl>
                            <dt>施工部位</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.place_info"
                                    placeholder="施工部位"
                                >
                            </dd>
                        </dl>
                        <dl>
                            <dt>标号</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.strength_info"
                                    placeholder="标号"
                                >
                            </dd>
                        </dl>
                        <dl>
                            <dt>浇筑方式</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.pouring_name"
                                    placeholder="浇筑方式"
                                >
                            </dd>
                        </dl>
                        <dl class="time">
                            <dt>申请时间</dt>
                            <dd>
                                <input
                                    type="text"
                                    v-model="requestData.start_time"
                                    placeholder="请选择开始时间"
                                    @click="selectTime('start_time')"
                                    readonly
                                >
                                <span>—</span>
                                <input
                                    type="text"
                                    v-model="requestData.end_time"
                                    placeholder="请选择结束时间"
                                    @click="selectTime('end_time')"
                                    readonly
                                >
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="confirmSelect">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
            <van-popup
                v-model="timeShow"
                position="bottom"
                round
                :style="{ height: 'auto' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    :formatter="formatter"
                    @cancel="cancelSelect"
                    @confirm="confirmSelectTime"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 订单下发
    name: 'order-issue',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'order-issue');
        }
        next();
    },
    data() {
        return {
            // 筛选侧滑菜单状态
            popupShow: false,
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 搜索字段
            value: '',
            // 订单数据集合
            orderData: [],
            // 列表总条数
            total: 0,
            // 时间选择器控件状态
            timeShow: false,
            // 选择时间
            currentDate: new Date(),
            // 当前打开时间控件对象
            selectTimeObj: '',
            // 筛选列表数据
            requestData: {
                // 场站id
                station_id: '',
                // 单位
                customer_name: '',
                // 工程名称
                project_name: '',
                // 施工部位
                place_info: '',
                // 标号
                strength_info: '',
                // 浇筑方式
                pouring_name: '',
                // 开始时间
                start_time: this.getDay(-3),
                // 结束时间
                end_time: this.getDay(+2),
                // 页码
                pageindex: 0,
                // 页大小
                pagesize: 2,
            },
            // 场站列表
            stationList: [{
                value: '',
                text: '全部',
            }],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getStation();
    },
    mounted() {},
    activated() {
        // 下发成功刷新列表
        if (this.$route.params.isRefreshList) {
            this.onRefresh();
        }
    },
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 打开订单详情
        openOrderDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/productionTask', query: { data: data } });
        },
        // 展开筛选菜单
        showPopup() {
            this.popupShow = true;
        },
        // 关闭筛选菜单
        onClickRight() {
            this.popupShow = false;
        },
        // 确认筛选
        confirmSelect() {
            this.popupShow = false;
            this.orderData = [];
            this.requestData.pageindex = 1;
            this.finished = false;
            this.getOrderData();
        },
        // 重置筛选条件
        resetSelect() {
            this.requestData.station_id = '';
            this.requestData.customer_name = '';
            this.requestData.project_name = '';
            this.requestData.place_info = '';
            this.requestData.strength_info = '';
            this.requestData.pouring_name = '';
            this.requestData.start_time = this.getDay(-3);
            this.requestData.end_time = this.getDay(+2);
            this.requestData.pageindex = 0;
            this.requestData.pagesize = 2;
        },
        // 下拉刷新
        onRefresh() {
            this.orderData = [];
            this.requestData.pageindex = 1;
            this.getOrderData();
        },
        // 上拉加载更多
        onLoad() {
            this.requestData.pageindex++;
            this.getOrderData();
        },
        // 拉取订单数据
        getOrderData() {
            this.$axios
                .post('/interfaceApi/production/producttask/page', this.requestData)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.total = res.total;
                        if (this.orderData.length < 1) {
                            this.orderData = res.rows;
                            this.finished = false;
                        } else {
                            res.rows.forEach(item => {
                                this.orderData.push(item);
                            });
                        }
                        if (this.orderData.length === this.total) {
                            this.finished = true;
                        }
                    } else {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 时间戳转为日期
        formatDate: function (d) {
            return d.getFullYear() + '-' + this.p(d.getMonth() + 1) + '-' + this.p(d.getDate());
        },
        // 时间补零
        p(s) {
            return s < 10 ? '0' + s : s;
        },
        // 打开选择时间控件
        selectTime(obj) {
            this.currentDate = new Date(this.requestData[obj]);
            this.selectTimeObj = obj;
            this.timeShow = true;
        },
        // 取消选择时间
        cancelSelect() {
            this.timeShow = false;
        },
        // 确认选择时间
        confirmSelectTime(d) {
            this.currentDate = this.formatDate(d);
            this.timeShow = false;
            this.requestData[this.selectTimeObj] = this.currentDate;
        },
        // 处理控件显示的时间格式
        formatter(type, value) {
            // 格式化选择器日期
            if (type === 'year') {
                return `${value}年`;
            } if (type === 'month') {
                return `${value}月`;
            } if (type === 'day') {
                return `${value}日`;
            } if (type === 'hour') {
                return `${value}时`;
            } if (type === 'minute') {
                return `${value}分`;
            }
            return value;
        },
        // 获取指定时间
        getDay(day) {
            const today = new Date();
            const targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds);
            const tYear = today.getFullYear();
            let tMonth = today.getMonth();
            let tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear + '-' + tMonth + '-' + tDate;
        },
        // 时间补零
        doHandleMonth(month) {
            let m = month;
            if (month.toString().length === 1) {
                m = '0' + month;
            }
            return m;
        },

        // 获取供应场站
        getStation() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.stationList.push(...stationList);
            }
        },
    },
};
</script>
<style lang="stylus" scoped>
.orderIssue
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow-y auto
        .list
            height calc(100% - 45rpx)
            overflow-y auto
            background #F0F0F0
            padding 15rpx
            padding-bottom 0
            li
                width 100%
                background #fff
                overflow hidden
                margin-bottom 15rpx
                .state
                    position absolute
                    top 15rpx
                    right 15rpx
                    font-size 12rpx
                    color #D60110
                    font-weight 400
                //     .telephone
                //         width 25rpx
                //         height 25rpx
                //         background url(./../../../assets/images/clueManagement/phone@2x.png)
                //         background-size 100% 100%
                //         border none
                //         position absolute
                //         right 15rpx
                //         bottom 0
                // .btns
                //     padding 0 6rpx
                //     text-align center
                //     margin-bottom 14rpx
                //     button
                //         border 1px solid #D7D7D7
                //         border-radius 4rpx
                //         background #fff
                //         height 32rpx
                //         margin 0 25rpx
                //         font-size 14rpx
                //         color #333333
                //         width calc((100% - 100rpx)/2)
                //         img
                //             width 16rpx
                //             vertical-align middle
                //             margin-top -4rpx
    // .contactInfo
    //     h5,p
    //         font-size 16rpx
    //         line-height 45rpx
    //         text-align center
    //     h5
    //         color #333333
    //         background #F8F8F8
    //     p
    //         color #0189FC
    //         border-bottom 1px solid  #F0F0F0
    .screen
        height 100%
        section
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            dt
                font-size 14rpx
            dd
                margin-top 14rpx
                input
                    width 100%
                    height 32rpx
                    border 1px solid #F0F0F0
                    padding-left 6rpx
                    font-size 14rpx
                >>> .van-dropdown-menu
                    .van-dropdown-menu__bar
                        border: 1px solid #f0f0f0;
                        height 32rpx
                        box-shadow: none;
                        .van-dropdown-menu__item
                            justify-content flex-start
                            .van-dropdown-menu__title
                                width 90%;
                                font-size 14rpx
            .time
                span,input
                    float left
                span
                    width 28rpx
                    line-height 32rpx
                    color #D7D7D7
                    text-align center
                input
                    width calc((100% - 28rpx)/2)
</style>
